import { render, staticRenderFns } from "./PlacementTestResults.vue?vue&type=template&id=eef6dff6&"
import script from "./PlacementTestResults.vue?vue&type=script&lang=js&"
export * from "./PlacementTestResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports